import { atom } from 'jotai';
import { $CurrentDiscoverKeyword } from '@discover/shared/atom/current-discover-keyword';
import { $DiscoverData } from 'shared/atoms';
import { DiscoverUtil, IDiscoverData, IDiscoverUnavailableData } from 'shared/models';

export const $CurrentDiscoverData = atom<Promise<IDiscoverData | IDiscoverUnavailableData>>((get) => {
  const keyword = get($CurrentDiscoverKeyword);

  return get($DiscoverData(keyword));
});

export const $CurrentAvailableDiscoverDataOrNull = atom<Promise<IDiscoverData | null>>(async (get) => {
  const keyword = get($CurrentDiscoverKeyword);

  const data = await get($DiscoverData(keyword));
  if (DiscoverUtil.isDiscoverDataAvailable(data)) {
    return data;
  }

  return null;
});

export const $CurrentDiscoverDataAsAvailable = atom<Promise<IDiscoverData>>((get) => {
  const keyword = get($CurrentDiscoverKeyword);

  return get($DiscoverData(keyword)) as Promise<IDiscoverData>;
});
